import React from "react";
import { Route, Switch, Link } from "react-router-dom";
import { TableHeaderNoAdd, OrangeLinkButton } from "./formComponents";
import { Row } from "react-bootstrap";
import RoleForm from "./roleForm";
import RoleTable from "./roleTable";
import RoleAssignPermission from "./roleAssignPermission";
import { Container } from "./styleCustom";

const Roles = (props) => {
  return (
    <Container style={{ flexWrap: "wrap", flex: "0 0 100%" }}>
      <Route
        path={`/admin/setup/roles/rolepermission/:id`}
        component={RoleAssignPermission}
      />
      <div style={{ flex: "1 1 100%" }}>
        <TableHeaderNoAdd title="Roles">
          <Link to={`${props.match.url}/roleform/add`}>
            <OrangeLinkButton>{"Add New Role"} </OrangeLinkButton>{" "}
          </Link>
        </TableHeaderNoAdd>
        <Switch>
          <Route path={`/admin/setup/roles/`} component={RoleTable} />
        </Switch>
      </div>

      <div style={{ order: 1, flex: "0 0 auto" }}>
        <Row>
          <Route
            path={`${props.match.url}/roleform/:addoredit`}
            component={RoleForm}
          />
        </Row>
      </div>
    </Container>
  );
};

export default Roles;
